import { type FieldError, type Control, type FieldPath, type FieldValues, useController } from 'react-hook-form';
import MultiSelect, { type MultiSelectProps } from '../MultiSelect';
import './ControlledMultiSelect.css';

export interface ControlledMultiSelectProps<TFieldValues extends FieldValues = FieldValues> extends Omit<MultiSelectProps, 'error' | 'value' | 'onChange'> {
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    error?: FieldError;
    /** false — не показывать ошибку (для визарда до нажатия «Далее»/submit) */
    showError?: boolean;
}

export default function ControlledMultiSelect<TFieldValues extends FieldValues = FieldValues>({
    name,
    control,
    error: errorProp,
    showError = true,
    className = '',
    ...props
}: ControlledMultiSelectProps<TFieldValues>) {
    // Используем useController для работы с формой
    const { field, fieldState } = useController({
        control,
        name,
    });

    const error = showError ? fieldState.error || errorProp : undefined;

    const handleChange = (values: (string | number)[]) => {
        field.onChange(values);
    };

    const handleBlur = () => {
        field.onBlur();
    };

    return (
        <div className="controlled-multiselect-wrapper">
            <MultiSelect
                className={className}
                value={field.value || []}
                onChange={handleChange}
                onBlur={handleBlur}
                {...props}
                // error обязательно ПОСЛЕ props, иначе rest перезапишет
                error={error ? error.message : undefined}
            />
        </div>
    );
}

